// App state updates
export const UPDATE_APP_STATE = 'app/UPDATE_APP_STATE';

// Async location fetch
export const FETCH_LOCATION = 'app/FETCH_LOCATION';
export const FETCH_LOCATION_SUCCESS = 'app/FETCH_LOCATION_SUCCESS';
export const FETCH_LOCATION_FAILURE = 'app/FETCH_LOCATION_FAILURE';
